import { Component } from '@angular/core'

@Component({
  selector: 'app-legend',
  templateUrl: './legend-base.component.html',
  standalone: false,
})
export class LegendComponent {}
